export default () => {
  return {
    /**
     * Whether the user is currently online or offline
     */
    networkOnline: true,
    offlineMode: false,
    switchingModes: false,
    forceOffline: false,
  };
};
